import Image from "next/image";

import type { PostType } from "@sorcery/cms";
import { H3, InternalLink, P } from "@sorcery/ui";
import { getSanityImageUrl } from "@sorcery/utils/client/sanity";

import { env } from "~/env";
import { newsItemPath } from "~/utils/paths";
import { PostPreview } from "./PostPreview";

export const PostPreviewSmall = ({ post }: { post: PostType }) => {
  const { coverImage, excerpt, title, slug } = post;
  return (
    <div>
      {/* big screen */}

      <InternalLink
        className="group hidden flex-col duration-300 hover:scale-[1.02] hover:opacity-50 sm:flex sm:flex-row"
        href={newsItemPath(slug)}
      >
        {/* group-hover:scale-105 */}
        <div className="relative mb-4 mr-6 hidden w-[320px] transition-all sm:block">
          <Image
            height={320}
            width={640}
            alt={"Cover Image"}
            // higher so the image is sharper. Gets compressed by nextjs
            src={getSanityImageUrl(
              coverImage,
              env.NEXT_PUBLIC_SANITY_PROJECT_ID,
              env.NEXT_PUBLIC_SANITY_DATASET,
            )
              .height(320)
              .width(640)
              .url()}
          />

          <div
            className="absolute top-0 hidden h-full w-full duration-500 animate-in fade-in group-hover:block"
            style={{
              backgroundImage: `
      linear-gradient(240deg, rgba(2, 2, 2, 0.1) 0%, rgba(2, 2, 2, 0.05) 40%), 
      linear-gradient(120deg, rgba(2, 2, 2, 0.1) 0%, rgba(2, 2, 2, 0.05) 40%), 
      linear-gradient(180deg, rgba(2, 2, 2, 0.1) 0%, rgba(2, 2, 2, 0.05) 40%)`,
            }}
          />
        </div>

        <div className="mr-2 sm:w-2/3">
          <H3 className="!mb-2 line-clamp-2 text-big-text-color transition-all">{title}</H3>
          <P className="line-clamp-2 opacity-70">{excerpt}</P>
        </div>
      </InternalLink>

      {/* sm screen */}

      <div className="sm:hidden">
        <PostPreview post={post} />
      </div>
    </div>
  );
};
